import React, { PureComponent } from 'react';
import { Card, CardBody, Col } from 'reactstrap';
import { Field, reduxForm } from 'redux-form';
import renderInputField from '../../../shared/components/form/renderInput';
import { withTranslation } from 'react-i18next';

class AdSense extends PureComponent {

  render() {
    const { handleSubmit, t } = this.props;

    return (
      <Col xs={12} md={12} lg={12} xl={12}>
        <Card>
          <CardBody>
            <div className="card__title">
              <h5 className="bold-text">{t('settings.adsense.title')}</h5>
            </div>
            <p>{t('settings.adsense.description')}</p>
            <form className="form form--horizontal" onSubmit={handleSubmit}>
              <div className="form__form-group">
                <span className="form__form-group-label">{t('settings.adsense.form_publisher_id.label')}:</span>
                <div className="form__form-group-field">
                  <Field
                    name="adsense_publisher_id"
                    component={renderInputField}
                    type="text"
                    placeholder="pub-xxxxxxxxxxxxxxxx"
                  />
                </div>
              </div>
            </form>
          </CardBody>
        </Card>
      </Col>
    );
  }
}

export default reduxForm({
  form: 'blog_settings',
  enableReinitialize: true
})(withTranslation('dashboard')(AdSense));
